"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _luxon = require("luxon");
var _lodash = require("lodash");
var _addToCalendar = require("../utils/addToCalendar");
var _BrixelDropdown = _interopRequireDefault(require("./BrixelDropdown"));
var _translation = _interopRequireDefault(require("../Translation/translation"));
var _reactRedux = require("react-redux");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const AddToCalendar = props => {
  const timezone = -(new Date().getTimezoneOffset() / 60);
  const {
    title,
    lang = 'en',
    location = '',
    timestamp = null,
    translations
  } = props;
  const calendarList = [{
    label: 'iCal',
    value: 'ical',
    icon: 'ical'
  }, {
    label: 'Google',
    value: 'google',
    icon: 'google'
  }, {
    label: 'Microsoft 365',
    value: 'microsoft',
    icon: 'microsoft365'
  }, {
    label: 'Microsoft Teams',
    value: 'microsoftTeam',
    icon: 'microsoft-teams'
  }];
  const isBrowser = new Function('try { return this===window; }catch(e){ return false; }');
  const isiOS = isBrowser() ? new Function('if ((/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) || (navigator.platform === \'MacIntel\' && navigator.maxTouchPoints > 1)){ return true; }else{ return false; }') : new Function('return false;');
  const formatCalendar = type => {
    if (timestamp) {
      switch (type) {
        case 'start':
          {
            const date = _luxon.DateTime.fromMillis(timestamp).toFormat('yyyy-LL-dd', {
              locale: lang
            });
            return `${date}`;
          }
        case 'end':
          {
            const date = _luxon.DateTime.fromMillis(timestamp).toFormat('yyyy-LL-dd', {
              locale: lang
            });
            return `${date}`;
          }
        case 'startTime':
          {
            const startTime = _luxon.DateTime.fromMillis(timestamp).toFormat('hh:mm', {
              locale: lang
            });
            return startTime;
          }
        case 'endTime':
          {
            const endTime = _luxon.DateTime.fromMillis(timestamp).toFormat('hh:mm', {
              locale: lang
            });
            return endTime;
          }
      }
    }
  };
  // FUNCTION TO GENERATE THE GOOGLE URL
  const generate_google = data => {
    // base url
    let url = 'https://calendar.google.com/calendar/render?action=TEMPLATE';
    // generate and add date
    const formattedDate = (0, _addToCalendar.generate_time)(data, 'clean', 'google');
    url += '&dates=' + formattedDate['start'] + '%2F' + formattedDate['end'];
    // add details (if set)
    if (data['name'] != null && data['name'] != '') {
      url += '&text=' + encodeURIComponent(data['name']);
    }
    if (data['location'] != null && data['location'] != '') {
      url += '&location=' + encodeURIComponent(data['location']);
      // TODO: Find a better solution for the next temporary workaround.
      if (isiOS()) {
        // workaround to cover a bug, where, when using Google Calendar on an iPhone, the location is not recognized. So, for the moment, we simply add it to the description.
        if (data['description'] == null || data['description'] == '') {
          data['description'] = '';
        } else {
          data['description'] += '<br><br>';
        }
        data['description'] += '&#128205;: ' + data['location'];
      }
    }
    if (data['description'] != null && data['description'] != '') {
      url += '&details=' + encodeURIComponent(data['description']);
    }
    if (typeof window !== 'undefined') {
      const w = window.open(url, '_blank');
      if (w) w.focus();
    }
  };
  const generate_ical = data => {
    let now = new Date();
    now = now.toISOString().replace(/\..../g, '').replace(/[^a-z0-9]/gi, '');
    const formattedDate = (0, _addToCalendar.generate_time)(data, 'clean', 'ical');
    let timeslot = '';
    if (formattedDate['allday']) {
      timeslot = ';VALUE=DATE';
    }
    const ics_lines = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'CALSCALE:GREGORIAN', 'BEGIN:VEVENT', 'DTSTAMP:' + formattedDate['start'], 'DTSTART' + timeslot + ':' + formattedDate['start'], 'DTEND' + timeslot + ':' + formattedDate['end'], 'SUMMARY:' + data['name']];
    if (data['description_iCal'] != null && data['description_iCal'] != '') {
      ics_lines.push('DESCRIPTION:' + data['description_iCal'].replace(/\n/g, '\\n'));
    }
    if (data['location'] != null && data['location'] != '') {
      ics_lines.push('LOCATION:' + data['location']);
    }
    ics_lines.push('STATUS:CONFIRMED', 'LAST-MODIFIED:' + now, 'SEQUENCE:0', 'END:VEVENT', 'END:VCALENDAR');
    const dlurl = 'data:text/calendar;charset=utf-8,' + encodeURIComponent(ics_lines.join('\r\n'));
    try {
      if (!(0, _lodash.get)(window, 'ActiveXObject', null)) {
        const save = document.createElement('a');
        save.href = dlurl;
        save.target = '_blank';
        save.download = data['iCalFileName'] || 'event-to-save-in-my-calendar';
        const evt = new MouseEvent('click', {
          'view': window,
          'bubbles': true,
          'cancelable': false
        });
        save.dispatchEvent(evt);
        (window.URL || window.webkitURL).revokeObjectURL(save.href);
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  };
  const generate_microsoft = (data, type = '365') => {
    // base url
    let url = 'https://';
    if (type == 'outlook') {
      url += 'outlook.live.com';
    } else {
      url += 'outlook.office.com';
    }
    url += '/calendar/0/deeplink/compose?path=%2Fcalendar%2Faction%2Fcompose&rru=addevent';
    // generate and add date
    const formattedDate = (0, _addToCalendar.generate_time)(data, 'delimiters', 'microsoft');
    url += '&startdt=' + formattedDate['start'] + '&enddt=' + formattedDate['end'];
    if (formattedDate['allday']) {
      url += '&allday=true';
    }
    // add details (if set)
    if (data['name'] != null && data['name'] != '') {
      url += '&subject=' + encodeURIComponent(data['name']);
    }
    if (data['location'] != null && data['location'] != '') {
      url += '&location=' + encodeURIComponent(data['location']);
    }
    if (data['description'] != null && data['description'] != '') {
      url += '&body=' + encodeURIComponent(data['description'].replace(/\n/g, '<br>'));
    }
    if (typeof window !== 'undefined') {
      const w = window.open(url, '_blank');
      if (w) w.focus();
    }
  };
  const generate_teams = data => {
    // base url
    let url = 'https://teams.microsoft.com/l/meeting/new?';
    // generate and add date
    const formattedDate = (0, _addToCalendar.generate_time)(data, 'delimiters', 'microsoft');
    url += '&startTime=' + formattedDate['start'] + '&endTime=' + formattedDate['end'];
    // add details (if set)
    let locationString = '';
    if (data['name'] != null && data['name'] != '') {
      url += '&subject=' + encodeURIComponent(data['name']);
    }
    if (data['location'] != null && data['location'] != '') {
      locationString = encodeURIComponent(data['location']);
      url += '&location=' + locationString;
      locationString += ' // '; // preparing the workaround putting the location into the description, since the native field is not supported yet
    }
    if (data['description_iCal'] != null && data['description_iCal'] != '') {
      // using description_iCal instead of description, since Teams does not support html tags
      url += '&content=' + locationString + encodeURIComponent(data['description_iCal']);
    }
    if (typeof window !== 'undefined') {
      const w = window.open(url, '_blank');
      if (w) w.focus();
    }
  };
  const clickForm = type => {
    const data = {
      name: title,
      startDate: formatCalendar('start'),
      endDate: formatCalendar('end'),
      startTime: formatCalendar('startTime'),
      endTime: formatCalendar('endTime'),
      options: ['Apple', 'Google', 'iCal', 'Microsoft365', 'Outlook.com', 'MicrosoftTeams', 'Yahoo'],
      trigger: 'click',
      location: location,
      timeZoneOffset: `+0${timezone}:00`,
      iCalFileName: `${title} - Visit`
    };
    switch (type) {
      case 'google':
        generate_google(data);
        break;
      case 'ical':
        generate_ical(data);
        break;
      case 'microsoft':
        generate_microsoft(data);
        break;
      case 'microsoftTeam':
        generate_teams(data);
        break;
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_BrixelDropdown.default, {
    className: "w-fit addToCalendar",
    options: calendarList,
    onSelect: (_e, val) => clickForm(val.value),
    selected: (0, _translation.default)('Add to calendar', lang, null, translations),
    borderColor: "green",
    color: "green",
    liClass: "ws-nw"
  }));
};
const mapStateToProps = state => ({
  translations: (0, _lodash.get)(state, 'translations', {})
});
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(AddToCalendar);